export enum MedioDePago {
  TARJETA_DE_CREDITO = 'TDC',
  OTRO_MEDIO_DE_PAGO = 'PSE',
  PSE = '_PSE_',
  BANCOLOMBIA = 'BTNBC',
  MEDIO_PAGO_SELECCIONADO = 'Medio de pago',
  PLACE_TO_PAY = 'PTP',
}
